import * as React from "react";
import { useTranslation } from "react-i18next";

import { GettingStartedLayout } from "components/products/GettingStartedLayout";
import { LicenseData } from "domain/licenses";
import { OnboardingProductType } from "domain/onboardings";
import { OnboardingImage, SoftwarePackage, Versions } from "domain/softwarePackages";

interface Props {
    licenses: Versions[];
    fetchedLicenses: LicenseData[];
    fetchedSoftwarePackages?: SoftwarePackage[];
    saveBarOnboarded: (onboarded: boolean) => void;
    showBmpSetup: boolean;
    saveLastCompletedStep: (step: string) => void;
    fetchedOnboardingImages: OnboardingImage[];
}

export const GettingStarted = (props: Props): JSX.Element => {
    const { t } = useTranslation();

    return (
        <GettingStartedLayout
            product={OnboardingProductType.BAR}
            visible={true}
            footerVisibility={false}
            extraHeaderText={t("Onboarding.barHomePage.gettingStarted.extraHeaderText")}
            title={t("Onboarding.barHomePage.gettingStarted.title")}
            description={t("Onboarding.barHomePage.gettingStarted.description")}
            licenses={props.licenses}
            fetchedLicenses={props.fetchedLicenses}
            fetchedSoftwarePackages={props.fetchedSoftwarePackages}
            saveBarOnboarded={props.saveBarOnboarded}
            showBmpSetup={props.showBmpSetup}
            saveLastCompletedStep={props.saveLastCompletedStep}
            fetchedOnboardingImages={props.fetchedOnboardingImages}
        />
    );
};

export default GettingStarted;
